import {AfterViewInit, Component, HostListener, Inject, Injectable, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { AuswertungState } from '../../store/reducer/auswertungen.reducer';
import {BestaetigungsFormComponent} from '../../../../ui-components/bestaetigungs-form/bestaetigungs-form.component';
import {Observable} from 'rxjs';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {loadAllMitarbeiterSelectboxStart} from '../../../Mitarbeiterverwaltung/store/actions/getAllMitarbeiterSelectbox.actions';
import {State} from '../../../Mitarbeiterverwaltung/store/reducer/mitarbeiterverwaltung.reducer';
import {MitarbeiterItem} from '../../../Mitarbeiterverwaltung/mitarbeiter.model';
import { getFilteredZeitStarted} from '../../store/actions/filter-seek-date.actions';
import {AddButtonFormdialogComponent} from '../../../landingpage/components/addButton-form-dialog/addButton-formdialog.component';
import {AuswertungenFormdialogNeuComponent} from '../auswertungen-formdialog-neu/auswertungen-formdialog-neu.component';
import {loadZeitStart} from '../../store/actions/Zeit-output.actions';
import * as moment from 'moment';
import {loadSpesenStart} from '../../../Zeiterfassung/store/actions/getAllSpesen.actions';
import {Router} from '@angular/router';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import {AuswertungenTableComponent} from '../auswertungen-table/auswertungen-table.component';


@Component({
  selector: 'app-auswertungen-page',
  templateUrl: './auswertungen-page.component.html',
  styleUrls: ['./auswertungen-page.component.scss']
})

export class AuswertungenPageComponent implements OnInit {

  @ViewChild(AuswertungenTableComponent) child: AuswertungenTableComponent;


  // tslint:disable-next-line:max-line-length
  constructor( public dialog: MatDialog, public store: Store<{ auswertungen: AuswertungState }> , private mitarbeiterStore: Store<{ mitarbeiterverwaltung: State }>, private _router: Router , ) {

    this.$zeit = store.pipe(select((state) => state.auswertungen.item)); /* items */
    this.$user = mitarbeiterStore.pipe(select((state) => state.mitarbeiterverwaltung.selectboxItems));
    this.rolleId = sessionStorage.getItem('rolleId');

  }
  public rolleId: string;
  public title;
  public functionMenuEnabled: boolean;
  public $zeit;
  public wertDerCheckboxPage;

  public $user: Observable<MitarbeiterItem[]>;

  public userForm = new FormGroup({
    user: new FormControl('', [Validators.required]),
  });

  @HostListener('window:beforeunload', [ '$event' ])
  // tslint:disable-next-line:typedef
  beforeUnloadHandler(event) {
    sessionStorage.setItem('zeitUserId', 'null');
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('rolleId') != '1' && sessionStorage.getItem('rolleId') != '2') {
      this._router.navigate(['landingpage']);
    }
  }


  public openFilter(): void{
    const today = new Date();
    const dialogRef = this.dialog.open(AuswertungenFormdialogNeuComponent, {
      data: {
        title: 'pages.auswertungen.auswertungDialog.title',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
        start: new Date(today.getFullYear(), today.getMonth(), 1),
        ende: new Date(today.getFullYear(), today.getMonth() + 1, 0),
      },
    }).afterClosed().subscribe(
      (result) => {
        this.child.loadReport(result.benutzer, result.zwischensummen, result.details, result.separat, result.alleBenutzer, result.start, result.ende, result.zeitAuswahl);
        this._router.navigate(['auswertungen']);
      }
    );
  }

  public wandler(datum: any): any {
    // tslint:disable-next-line:triple-equals
    if (datum == undefined){
      return null;
    }
    const dwD = datum.toLocaleString( 'en-US', {timezone: 'utc'} );
    const backendDat = moment(dwD).format('YYYY-MM-DD');
    return backendDat;
  }



}
